import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from '@/contexts/AuthContext';
import { ProtectedRoute } from '@/components/ProtectedRoute';
import { Navbar } from '@/components/Navbar';
import { Home } from '@/pages/Home';
import { Login } from '@/pages/Login';
import { Register } from '@/pages/Register';
import { ForgotPassword } from '@/pages/ForgotPassword';
import { ResetPassword } from '@/pages/ResetPassword';
import { Listings } from '@/pages/Listings';
import { PropertyDetails } from '@/pages/PropertyDetails';
import { HowItWorks } from '@/pages/HowItWorks';
import { Pricing } from '@/pages/Pricing';
import { TrustAndSafety } from '@/pages/TrustAndSafety';
import { Contact } from '@/pages/Contact';
import { ListProperty } from '@/pages/ListProperty';
import { CreateListing } from '@/pages/CreateListing';
import { PaymentSuccess } from '@/pages/PaymentSuccess';
import { PaymentCancel } from '@/pages/PaymentCancel';
import { YocoPaymentSuccess } from '@/pages/YocoPaymentSuccess';
import { YocoPaymentCancelled } from '@/pages/YocoPaymentCancelled';
import { HostDashboard } from '@/pages/HostDashboard';
import { GuestDashboard } from '@/pages/GuestDashboard';
import { AdminDashboard } from '@/pages/AdminDashboard';
import { Toaster } from '@/components/ui/sonner';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="App">
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route
              path="/*"
              element={
                <>
                  <Navbar />
                  <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/listings" element={<Listings />} />
                    <Route path="/listings/:id" element={<PropertyDetails />} />
                    <Route path="/how-it-works" element={<HowItWorks />} />
                    <Route path="/pricing" element={<Pricing />} />
                    <Route path="/trust-and-safety" element={<TrustAndSafety />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/list-property" element={<ListProperty />} />
                    <Route path="/payment/success" element={<PaymentSuccess />} />
                    <Route path="/payment/cancel" element={<PaymentCancel />} />
                    <Route path="/payment-success" element={<YocoPaymentSuccess />} />
                    <Route path="/payment-cancelled" element={<YocoPaymentCancelled />} />
                    <Route
                      path="/host/dashboard"
                      element={
                        <ProtectedRoute requiredRole="host">
                          <HostDashboard />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/host/create-listing"
                      element={
                        <ProtectedRoute requiredRole="host">
                          <CreateListing />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/guest/dashboard"
                      element={
                        <ProtectedRoute requiredRole="guest">
                          <GuestDashboard />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/admin/dashboard"
                      element={
                        <ProtectedRoute requiredRole="admin">
                          <AdminDashboard />
                        </ProtectedRoute>
                      }
                    />
                  </Routes>
                </>
              }
            />
          </Routes>
          <Toaster />
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
